<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="800px">
    <div class="fill-height">


      <v-card class="fill-height">

        <v-card-subtitle>تعریف/ویرایش مدیر ساختمان</v-card-subtitle>
        <v-spacer/>


        <v-card-text>


          <v-form  ref="form" @submit.prevent="save" lazy-validation v-model="valid">
            <v-row>
              <v-col
                  cols="12"
                  sm="6"
                  md="4">

                <v-autocomplete
                    :items="modelItems.userList"
                    v-model="modelItems.model.userId"
                    label="انتخاب شخص"
                    @input="handleInput"
                    dense
                    outlined
                    :error-messages="getError('userId')"
                />
              </v-col>

              <v-col
                  cols="12"
                  sm="6"
                  md="4">

                  <v-autocomplete
                      :items="modelItems.buildingList"
                      v-model="modelItems.model.buildingIds"
                      label="انتخاب مجتمع"
                      @input="handleInput"
                      dense
                      multiple
                      outlined
                      :error-messages="getError('buildingIds')"
                  />
              </v-col>

            </v-row>

            <v-divider class="p-0 m-0"/>
            <v-card-actions dir="ltr">

              <v-btn
                  depressed
                  small
                  color="primary"
                  class=" p-1 m-1"
                  type="submit"
                  :loading="loading"
              >
                ذخیره
              </v-btn>
              <v-btn
                  depressed
                  small
                  color="error"
                  class=" p-1 m-1"
                  @click="closed"
              >
                لغو
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import Manager_se from "./Manager_se";



export default {

  props: {
    dialogStatus: {
      default: false,
    },
    modelItems: Object,

  },
  data() {
    return {
      bindingErrors: [],
      valid: true,
      loading: false,
    }
  },




  methods: {
    handleInput (value) {
      this.$emit('input', value)
    },

    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find( ({ fieldName }) => fieldName === key );
        if(error && error.message ) return  error.message[0]
      }
      return ''
    },
    closed() {
      this.bindingErrors=[]
      this.$root.$emit('Manager')
      this.$root.$emit('ManagementManager')
      this.loading=false
      this.$emit('update:dialogStatus', false)
    },
    getListUnit(data){
      this.items=data;
    },

    save(){
      this.loading=true
      this.bindingErrors = []
      Manager_se.save(this.modelItems.model).then(response => {
          if (response && response.status === 200) {
            this.$snack({type: 'success'})
            this.closed()
          }else if (response && response.response.status === 400) {
            this.loading=false
            this.bindingErrors = response.response.data;
          }
        })

    },

  },



}
</script>


